/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@ba-ui-toolkit/button';
import SVGIcon from '@ba-ui-toolkit/svgicon';
import arrowLeft from '@ba-ui-toolkit/ba-graphics/dist/icons-js/arrow--left_16';
import { classnames as cx, Bidi, propsUtils } from '@ba-ui-toolkit/utils';
import styles from './backbutton.scss';
import stringResource from './nls/StringResource';

const backButtonClassName = styles.backButtonClassName.replace(/"/g, '');

const { sanitize, getInheritedProps } = propsUtils;

function getString(value) {
	return stringResource.get(value);
}

export default class BackButton extends Component {
	static propTypes = {
		...Button.propTypes,
		buttonType: PropTypes.oneOf(['standard', 'label', 'nav_pane']),
		dir: PropTypes.oneOf(['', 'ltr', 'rtl', 'auto']),
		label: PropTypes.string,
		textDir: PropTypes.oneOf(['', 'ltr', 'rtl', 'auto']),
		pageTextDir: PropTypes.oneOf(['', 'ltr', 'rtl', 'auto']),
		numShape: PropTypes.bool,
		pageNumShape: PropTypes.bool,
		className: PropTypes.string,
		style: PropTypes.object,
		getLocaleString: PropTypes.func,
	};

	static defaultProps = {
		getLocaleString: getString,
		buttonType: 'standard',
		className: '',
		style: {},
	};

	focus() {
		this._button && this._button.focus();
	}

	_ref = node => {
		this._button = node;
	};

	render() {
		const { buttonType, className, style, getLocaleString, label, ...others } = this.props;

		const dir = Bidi.resolveDir(this.props.label || '', this.props.dir);
		const classNames = cx(backButtonClassName, {
			[`${buttonType}`]: buttonType,
		});

		const icon = <SVGIcon iconId={arrowLeft.id} bidi />;
		const buttonPassthroughProps = getInheritedProps(others, Button);

		return (
			<div className={`${classNames} ${className}`} dir={dir} style={style}>
				<Button
					aria-label={label || getLocaleString('back')}
					label={label}
					{...sanitize(others, BackButton)}
					{...buttonPassthroughProps}
					variant="frameless"
					icon={icon}
					ref={this._ref}
				/>
			</div>
		);
	}
}
